import styled from 'styled-components';

export const Anchor = styled('a')`
  display: inline-block;

  svg {
    display: block;
    width: 220px;
    height: auto;
  }
`;
